/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Microsoft365Regular from './microsoft-365-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Microsoft365Regular {...validProps} />;
}
SvgComponent.iconName = 'microsoft365Regular';

export const Microsoft365RegularIcon = svgIconWrapper(SvgComponent);
